export default __webpack_public_path__ + "static/media/criteria-1.e5dd2b9e.jpg";